module.exports = __webpack_public_path__ + "img/08.81ffe728.png";